import {
  env,
  Navbar,
  OfflineModeBanner,
  SignalRV4GlobalConnection,
  SignalRV4Provider,
  SyncDocumentAttributes,
} from '@diana/core';
import { Outlet } from 'react-router-dom';
import { useNavMenuPages } from '../../hooks/useNavMenuPages';

export function Viewport() {
  const v4HubUrl = `${env('DIANA_API_V4_ENDPOINT')}/events`;
  const { pages, isActive } = useNavMenuPages();

  return (
    <SignalRV4Provider hubUrl={v4HubUrl}>
      <OfflineModeBanner />
      <Navbar pages={pages} isActivePage={isActive} />
      <Outlet />
      <SignalRV4GlobalConnection />
    </SignalRV4Provider>
  );
}

export function EcosystemViewport() {
  return (
    <SyncDocumentAttributes>
      <Viewport />
    </SyncDocumentAttributes>
  );
}
